import ky from 'ky';

export async function performRefresh() {
  const response = await ky.post('/auth/refresh', {}).json<{
    jwt: string;
    refresh: string;
  }>();

  return response;
}
